/* eslint-disable react-dom/no-dangerously-set-innerhtml */
import i18n from './i18n'
import css from './index.module.css'

import { itemClicked } from '#/local/repository'
import type { SearchResult, SearchResultList } from '#/local/service'

import { Svg } from '#/global/component/Image/Svg'

import { Config } from '#/global/helper/Config'

interface Props {
    onClose: () => void
    query: string
    searchResults: SearchResultList
}

export const Result = ({ onClose, query, searchResults }: Props) => {
    const productEshopContent = searchResults['products-eshop'].length > 0
    const articleContent = searchResults.articles.length > 0
    const rentalContent = searchResults['products-rental'].length > 0
    const categoryContent = searchResults['nodes-eshop'].length > 0
    const manufacturerContent = searchResults.manufacturers.length > 0
    const primaryContent = productEshopContent || articleContent
    const asideContent = rentalContent || categoryContent || manufacturerContent

    const t = i18n[Config.getLang()]

    return (
        <>
            <div className={css.overlay} onClick={onClose} />
            <div className={css.wrap}>
                <span className={css.close} onClick={onClose}>
                    <Svg src="/file/close1-c69c49d5.svg" alt="Close" />
                </span>
                <div className={css.content}>
                    {primaryContent && (
                        <div className={css.primary}>
                            {productEshopContent && (
                                <div className={css.productList}>
                                    <div className={css.label}>
                                        <Svg src="/file/search-product-2fd02385.svg" alt="Produkt" width={18} height={18} />
                                        <span>{t.product}</span>
                                    </div>
                                    <div className={css.list}>
                                        {searchResults['products-eshop'].map(product => (
                                            <a
                                                key={product.id}
                                                className={css.product}
                                                href={product.url}
                                                onClick={event => handleClick(event, query, product)}>
                                                <img src={product.image} alt={product.slug} width={80} height={80} />
                                                <span dangerouslySetInnerHTML={{ __html: product.name }} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {articleContent && (
                                <div className={css.articleList}>
                                    <div className={css.label}>
                                        <Svg src="/file/search-article-a0840e2d.svg" alt="Článek" width={18} height={18} />
                                        <span>{t.article}</span>
                                    </div>
                                    <div className={css.list}>
                                        {searchResults.articles.map(article => (
                                            <a
                                                key={article.id}
                                                className={css.article}
                                                href={article.url}
                                                onClick={event => handleClick(event, query, article)}>
                                                <span dangerouslySetInnerHTML={{ __html: article.name }} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {asideContent && (
                        <div className={css.aside}>
                            {rentalContent && (
                                <div className={css.rentalList}>
                                    <div className={css.label}>
                                        <Svg src="/file/search-rental-0ce77969.svg" alt="Půjčovna" width={18} height={18} />
                                        <span>{t.rental}</span>
                                    </div>
                                    <div className={css.list}>
                                        {searchResults['products-rental'].map(rental => (
                                            <a
                                                key={rental.id}
                                                className={css.rental}
                                                href={rental.url}
                                                onClick={event => handleClick(event, query, rental)}>
                                                <img src={rental.image} alt={rental.slug} width={80} height={80} />
                                                <span dangerouslySetInnerHTML={{ __html: rental.name }} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {categoryContent && (
                                <div className={css.categoryList}>
                                    <div className={css.label}>
                                        <Svg src="/file/search-category-85adabae.svg" alt="Kategorie" width={18} height={18} />
                                        <span>{t.category}</span>
                                    </div>
                                    <div className={css.list}>
                                        {searchResults['nodes-eshop'].map(category => (
                                            <a
                                                key={category.id}
                                                className={css.category}
                                                href={category.url}
                                                onClick={event => handleClick(event, query, category)}>
                                                <span dangerouslySetInnerHTML={{ __html: category.name }} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {manufacturerContent && (
                                <div className={css.manufactureList}>
                                    <div className={css.label}>
                                        <Svg src="/file/search-manufacture-f550ac58.svg" alt="Výrobce" width={18} height={18} />
                                        <span>{t.manufacture}</span>
                                    </div>
                                    <div className={css.list}>
                                        {searchResults.manufacturers.map(manufacturer => (
                                            <a
                                                key={manufacturer.id}
                                                className={css.manufacture}
                                                href={manufacturer.url}
                                                onClick={event => handleClick(event, query, manufacturer)}>
                                                <span dangerouslySetInnerHTML={{ __html: manufacturer.name }} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <a className={`${css.showAll} dek-button-red`} href={`/search/?query=${query}`} role="button">
                    {t.showAll}
                </a>
            </div>
        </>
    )
}

const handleClick = (event: React.MouseEvent, query: string, item: SearchResult) => {
    event.preventDefault()

    void itemClicked(query, item)

    window.location.href = item.url
}
